import React from 'react';
import { DollarSign, FileText } from 'lucide-react';
import LineItemDetails from './LineItemDetails';
import QuoteSummary from './QuoteSummary';
import { Quote } from '../../../models/workItem';

interface QuoteDetailsProps {
  quote: Quote;
}

const QuoteDetails: React.FC<QuoteDetailsProps> = ({ quote }) => {
  return (
    <div className="space-y-6">
      <div className="border-b pb-4">
        <div className="flex items-center gap-2 mb-4">
          <DollarSign className="h-5 w-5 text-primary" />
          <h3 className="font-bold text-lg">Cost Summary</h3>
        </div>
        <QuoteSummary quote={quote} />
      </div>

      <div>
        <div className="flex items-center gap-2 mb-4">
          <FileText className="h-5 w-5 text-primary" />
          <h3 className="font-bold text-lg">Line Items</h3>
        </div>
        <div className="space-y-4">
          {quote.analysis.lineItems.map((lineItem, index) => (
            <LineItemDetails key={index} lineItem={lineItem} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuoteDetails;
